module.exports = __webpack_public_path__ + "static/media/circle-profile-institutions.11ab7a4d.svg";